import React from 'react';

import {useHover} from 'hooks/useHover';
import SecondaryButton from '../Button/SecondaryButton';

export type ItemType = {
  icon?: string;
  title: string;
  subtitle?: string;
  descriptions?: string[];
  flag?: string;
  onClick?: () => void;
  buttonText?: string;
  buttonOnClick?: () => void;
};

export const DEFAULT_ICON = 'default';

type ItemProps = {
  data: ItemType;
};

function Item({
  data: {
    icon,
    title,
    subtitle,
    descriptions,
    onClick,
    flag,
    buttonText,
    buttonOnClick,
  },
}: ItemProps) {
  const {hovered, onMouseOver, onMouseLeave} = useHover();

  return (
    <div
      className={`bg-white rounded-huge p-4 flex flex-col justify-between ${
        hovered ? 'shadow-skyblue-200' : 'shadow-sm'
      }`}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
    >
      <div className={`flex ${buttonOnClick ? 'max-w-5/6' : 'w-full'}`}>
        {icon &&
          (icon === DEFAULT_ICON ? (
            // a temporary component for development
            <div className="w-12 h-12 rounded-lg bg-skyblue" />
          ) : (
            <div
              className="w-12 h-12 rounded-lg bg-cover bg-center"
              style={{backgroundImage: `url(${icon})`}}
            />
          ))}
        <div className="flex flex-col px-4 max-w-11/12">
          <div className="flex">
            <span className="text-xl font-semibold truncate">{title}</span>
            {flag && (
              <span className="text-sm text-lightseagreen bg-lightcyan py-1 px-2 rounded-large ml-2">
                {flag}
              </span>
            )}
          </div>
          <span className="text-eclipse">{subtitle}</span>
        </div>
      </div>
      {buttonOnClick && (
        <SecondaryButton
          onClick={(
            event?: React.MouseEvent<HTMLButtonElement, MouseEvent>
          ) => {
            event?.stopPropagation();

            buttonOnClick();
          }}
        >
          {buttonText}
        </SecondaryButton>
      )}
      {descriptions && (
        <ul className="w-full mt-2">
          {descriptions.map((desc: string) => (
            <li className="list-disc list-inside" key={desc}>
              {desc}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Item;
